<template>
  <NuxtLayout v-bind="{ backRoute }" name="overlay" nav-icon="arrow-left">
    <ProgressHeader v-bind="{ icon, progress }">
      <template v-if="title" #headline>
        {{ title }}
      </template>

      <p v-if="infoText">{{ infoText }}</p>

      <slot name="header" />
    </ProgressHeader>

    <div>
      <slot />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

import type { OverlayLayoutProps } from '~/layouts/overlay.vue'

type RegisterLayoutProps = Pick<OverlayLayoutProps, 'backRoute'> & {
  icon: LcIconName
  infoText?: string
  progress?: number
  title?: string
}

defineProps<RegisterLayoutProps>()
</script>
